export function formatTimeRangeSliderLabel(value: number) {
  if (value === 0) return '<1h'
  return `${value}h`
}
